import styled from 'styled-components';
import {HTMLAttributes} from 'react';
import { BaseContainer } from './BaseContainer';
import { useGlobalContext } from '../../contexts/global/GlobalContext';

export const ViewContainer = (props : ViewContainerProps) => {

	const {gameState} = useGlobalContext();

	return (
		<CenteringContainer gameState={gameState} activationGameState={props.activationGameState}>
			<Container {...props}>
				{props.children}
			</Container>
		</CenteringContainer>
	);
};

// styled components

const Container = styled(BaseContainer)`
	// Large screens
	@media (min-width: ${p => p.theme.responsive.media.lg}){
		width: 60%;
	}

	// Extra large screens
	@media (min-width: ${p => p.theme.responsive.media.xl}){
		width: 40%;
	}
`;

const CenteringContainer = styled.div<{gameState: number, activationGameState: number}>`
	position: absolute;
	inset:0;
	display: flex;
	justify-content: center;
	height: 100%;

	opacity: ${p => p.gameState === p.activationGameState ? 1 : 0};
	pointer-events: ${p => p.gameState === p.activationGameState ? 'all' : 'none'};
	transition: all 0.4s;
	transition-delay: ${p => p.gameState === p.activationGameState ? '.5s' : ''};
`;

// type

interface ViewContainerProps extends HTMLAttributes<HTMLDivElement>{
	activationGameState: number;
}